/*
 * Contact related services
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2021 Gallagher Bassett Services, Inc.
 */

import { Injectable } from '@angular/core';
import { Constants } from 'app/shared/config/constants';
import {
  HttpClient,
  HttpParams
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ContactsResponse,
  ContactType
} from 'app/shared/models';
import { UserService } from 'app/shared/services/user.service';

@Injectable ( {
  providedIn: 'root'
} )
export class ContactService {
  readonly url = Constants.contactsUrl;
  readonly pageSize = 50;

  constructor ( private http: HttpClient, private userService: UserService ) {
  }

  search ( criteria: any, contactTypes: ContactType, pageNumber = 1, pageSize = this.pageSize ): Observable<ContactsResponse> {
    const clientNumber = this.userService.currentClient?.clientNumber;
    const params = new HttpParams ().appendAll ( {
      includeDescendants: true, ...criteria,
      pageNumber,
      pageSize,
      clientNumber,
      contactTypes,
      searchType: 'SOFT_MATCH'
    } );
    return this.http.get<ContactsResponse> ( this.url, { params } );
  }
}
